<template>
  <div>
    <loading :loading="true" :lines="10"></loading>
    <form action="https://www.mystaffshop.co.uk/SSO/DoIBenefitSSO/" method="post" ref="benefitsForm" v-if="$route.query.benefitsPayload">
      <input type="hidden" name="SAMLResponse" :value="benefitsSAML">
    </form>
  </div>
</template>

<script>
import loading from '../components/UILoading'

export default {
  components: { loading },
  data: () => ({
    benefitsSAML: null
  }),
  mounted () {
    if (this.$route.query.payload) {
      this.$root.passedLogin = true
      window.axios.post('https://vp20cmrss5.execute-api.eu-west-2.amazonaws.com/Dev', {
        payload: this.$route.query.payload
      })
      .then(response => {
        let user = JSON.parse(response.data.user)
        user = (user.id) ? user : user[0]

        if (!user) {
          this.$root.passedPayload = false
          this.$root.passedLogin = false
          return this.$router.push('/login-failure')
        }

        this.$store.commit('setUser', user)
        this.$store.commit('accessToken', response.data.token)
        let path = localStorage.getItem('path') || '/'
        this.$router.push(path, () => {
          this.$root.finishLogin()
        })
      }).catch(error => {
        if (error) {
          this.$root.passedPayload = false
          this.$root.passedLogin = false
          return this.$router.push('/login-failure')
        }
      })
    } else if (this.$route.query.benefitsPayload) {
      this.$root.passedLogin = true
      window.axios.post('https://vp20cmrss5.execute-api.eu-west-2.amazonaws.com/Dev', {payload: this.$route.query.benefitsPayload})
        .then(response => {
          this.benefitsSAML = response.data.user.replace('{"xml":"', '').replace('"}', '')
          setTimeout(() => this.$refs.benefitsForm.submit())
        })
    } else if (!this.benefitsSAML && !this.$route.query.benefitsPayload && !this.$route.query.payload) {
      this.$router.push('/')
    }
  }
}
</script>
